// extracted by mini-css-extract-plugin
module.exports = {"content":"Layout-module--content--284sx reusable--fullWidth--3qHDO reusable--universalPadding--3wzSs"};